import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { startGenerarNuevoPedido, startUploadingFiles, startUploadingIdcfdi } from '../../redux/store/pedidos/thunks';
import { useHistory } from "react-router-dom";
import { Formik, Field } from 'formik';
import { NavbarCliente } from '../support/NavbarCliente';
import { startLoadingNoReg } from '../../redux/store/auth/thunks';
import { logout } from '../../redux/store/auth/authSlice';


export const GenerateClientScreen = () => {

  

  const dispatch = useDispatch();
  const [facturaRequerida, setFacturaRequerida] = useState(false);

  const { displayName, direccion, municipio, email, telefono, datosFactura, rfc, idcfdi, imagenidcfdi, docID } = useSelector(state => state.auth);
  const { imagenes, imagenID } = useSelector( state => state.pedidos);
  const history = useHistory();
  dispatch(startLoadingNoReg(false));


  if (displayName === null) {
    dispatch(logout("Ingresa con tu email y contraseña creados"));
  }

  const fechaActual = new Date();
  let dia = fechaActual.getDate();
  if (dia < 10) {
    dia = "0" + dia;
  }
  let mes = fechaActual.getMonth() + 1;
  if (mes < 10) {
    mes = "0" + mes;
  }
  const fechaformat = `${fechaActual.getFullYear()}-${mes}-${dia}`


let horas = fechaActual.getHours() * 60;
let minutos = fechaActual.getMinutes();
const horaLimite = horas + minutos;





//   if ( perfil === "Repartidor" || perfil === "Produccion") {
//     return <Redirect to="/" />
//   }

  const onFileInputChange = ({ target }) => {
    if (target.files === 0) return;
    dispatch(startUploadingFiles(target.files));
  }

  const onFileInputChangeIdcfdi = ({ target }) => {
    if (target.files === 0) return;
    dispatch(startUploadingIdcfdi(target.files));
  }


  return (
    <div>
      <NavbarCliente />
      <h1 className='settings__title'>{`Hola ${displayName}, registra tu pedido:`}</h1>
      {docID === "B8ulCbQyT5tUif3WxyAy" && (<p className='generate__noRegAviso'>Recuerda que si te registras podrás dar seguimiento a tu pedido, tus datos se llenarán de forma automática y podrás contar con un historial de pedidos realizados.</p>)}
      <div className='generate__container'>

        <Formik 
          initialValues={{
            cliente: email === "invitado.globaclean@gmail.com" ? "" : displayName,
            tipo: 'Cliente',
            direccion: email === "invitado.globaclean@gmail.com" ? "" : direccion,
            municipio: email === "invitado.globaclean@gmail.com" ? "" : municipio,
            rangoPrecio: 'Precio1',
            tipoPedido: 'Cliente Web',
            pedido: '',
            limite: '',
            comentarios: '',
            factura: 'No',
            formaPago: 'Una Exhibición',
            metodoPago: 'Efectivo',
            costoExtra: 'No',
            rfc: rfc !== undefined ? rfc : "",
            idcfdi: idcfdi !== undefined ? idcfdi : "",
            direccionFactura: '',
            cfdi: '',
            repartidor: 'Libre',
            sucursal: 'Libre',
            email: email === "invitado.globaclean@gmail.com" ? "" : email,
            telefono: email === "invitado.globaclean@gmail.com" ? "" : telefono,
            imagenes: [],
            imagenID: imagenidcfdi !== undefined ? imagenidcfdi : [],
          }}
          validate={(valores) => {
            let errores = {};
            // const lim = new Date(valores.limite).getTime();
            // const ahora = new Date().getTime();
            // const tiempo = lim - ahora;


  
            if (!valores.cliente) {
              errores.cliente = "El nombre del cliente es requerido"
            }

            if (!valores.tipo) {
              errores.tipo = "Requerido"
            }

            if (!valores.direccion) {
              errores.direccion = "La dirección del cliente es requerida"
            }

            if (!valores.municipio) {
              errores.municipio = "Requerido"
            }

            if (!valores.tipoPedido) {
              errores.tipoPedido = "Requerido"
            }

            if (!valores.pedido && imagenes.length < 1) {
              errores.pedido = "La información del pedido es requerida"
            }


            


            if (!valores.limite) {
              errores.limite = "La fecha de entrega es requerida"
            } else if (valores.limite < fechaformat) {
              errores.limite = "La fecha no puede ser anterior a la actual"
            } else if (valores.limite === fechaformat && horaLimite > 720) {
              errores.limite = "Para programar un pedido el mismo día, debe realizarse antes de las 12:00 horas"
            } else if (new Date(valores.limite).getDay() === 6) {
              errores.limite = "No es posible programar entregas en domingo"
            }


            if (valores.formaPago === "PPD") {
              valores.metodoPago = "Por Definir"
            }

            if (valores.factura === "Sí") {
              setFacturaRequerida(true);
              if (rfc !== undefined && idcfdi !== undefined) {
                valores.rfc = rfc;
                valores.idcfdi = idcfdi;
              }

            } else if (valores.factura === "No") {
              setFacturaRequerida(false);
            }
            
            if (valores.factura === "Sí" && !valores.rfc) {
              errores.rfc = "Requerido"
            }


              if (valores.factura === "Sí" && !valores.idcfdi && imagenidcfdi?.length < 1) {
              errores.idcfdi = "Requerido"
            }




        
            // if (!valores.rfc && valores.factura === "Sí") {
            //   errores.rfc = "El RFC del cliente es requerido"
            // }

            // if (valores.cfdi === '' && valores.factura === "Sí") {
            //   errores.cfdi = "Requerido"
            // }

            if (!valores.email) {
              errores.email = "El email es requerido";
            } else if (!/^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/.test(valores.email)) {
              errores.email = "El formato del email no es correcto"
            }

            if (valores.telefono === '') {
              errores.telefono = "El teléfono es requerido"
            } else if (valores.telefono.toString().length !== 10) {
              errores.telefono = "El número telefónico debe ser a 10 dígitos"
            }

            // if (!valores.direccionFactura && valores.factura === "Sí") {
            //   errores.direccionFactura = "La dirección de facturación es requerida"
            // }

            if (valores.repartidor !== "Libre" && valores.sucursal === "Libre") {
              errores.sucursal = "Asignar repartidor, requiere asignar sucursal"
            }

            if (valores.repartidor === "Libre" && valores.sucursal !== "Libre") {
              errores.repartidor = "Asignar sucursal, requiere asignar repartidor"
            }


            return errores;
          }}
          onSubmit={(valores, { resetForm }) => {
            valores.imagenes = imagenes;
            if (imagenID.length > 0) {
              valores.imagenID = imagenID;
            } else {
              valores.imagenID = imagenidcfdi;
            }



            
            if (new Date(valores.limite).getDay() === 5) {
              valores.limite = valores.limite + "T14:30"
            } else  {
              valores.limite = valores.limite + "T15:30"
            }


            let pantalla = '/pendientesCliente';
            if (docID === "B8ulCbQyT5tUif3WxyAy") {
              pantalla = "/generarCliente"
            }
          


            // if (valores.factura === "Sí" && !datosFactura) {
            //   startAgregarDatosFacturacion(uid, valores.rfc, valores.idcfdi);
            // }
            
            dispatch(startGenerarNuevoPedido(valores));
            resetForm();
            history.push(pantalla);
          }}
        >
          {({values, errors, touched, handleSubmit, handleChange, handleBlur}) => (
            <form className='generate__form' onSubmit={handleSubmit}>
            <div className='generate__form-section'>
              <p className='generate__sectionName'>Datos del Cliente</p>
              <div>
                <label className='generate__label'>
                  Cliente: 
                  <input
                    type="text"
                    placeholder="Ingresa el nombre del cliente" 
                    name="cliente" 
                    className='generate__input'
                    value={values.cliente}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                   {touched.cliente && errors.cliente && <div className='generate__error '>{errors.cliente}</div>}
                </label>

                <div style={{display: "none"}} className='generate__selectValidation'>
                <Field as="select" name="tipo" className='settings__selectInput'>
                    <option value='Cliente'>Cliente</option>
                    <option value="VIP">VIP</option>
                    <option value="Moderado">Moderado</option>
                    <option value="Bajo">Bajo</option>
                  </Field>  
                  {touched.tipo && errors.tipo && <div style={{marginTop: '0'}} className='generate__error '>{errors.tipo}</div>}   
                </div>

              </div>
  
              <div>
                <label className='generate__label'>
                  Dirección: 
                  <input 
                    type="text" 
                    placeholder="Ingresa la dirección del cliente" 
                    name="direccion" 
                    className='generate__input' 
                    value={values.direccion}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                  {touched.direccion && errors.direccion && <div className='generate__error'>{errors.direccion}</div>}
                </label>

                <div className='generate__selectValidation'>
                <Field as="select" name="municipio" className='settings__selectInput'>
                    <option value=''>Municipio</option>
                    <option value="Colima">Colima</option>
                    <option value="Villa de Álvarez">Villa de Álvarez</option>
                    <option value="Comala">Comala</option>
                    <option value="Cuauhtémoc">Cuauhtémoc</option>
                    <option value="Coquimatlán">Coquimatlán</option>
                    <option value="Tecomán">Tecomán</option>
                    <option value="Armería">Armería</option>
                    <option value="Ixtlahuacán">Ixtlahuacán</option>
                    <option value="Minatitlán">Minatitlán</option>
                    <option value="Manzanillo">Manzanillo</option>
                    <option value="Otro">Otro</option>
                  </Field>  
                  {touched.municipio && errors.municipio && <div style={{marginTop: '0'}} className='generate__error '>{errors.municipio}</div>}   
                </div>

              </div>

              <div className='generate__rangoTipo' style={{display:"none"}} >
                <div className='generate__selectValidation'>
                  <Field as="select" name="rangoPrecio" className='settings__selectInput'>
                      <option value="Precio 1">Precio 1</option>
                      <option value="Precio 2">Precio 2</option>
                      <option value="Precio 3">Precio 3</option>
                      <option value="Precio 4">Precio 4</option>
                      <option value="Precio 1 sin descuento">Precio 1 sin descuento</option>
                      <option value="Precio 2 sin descuento">Precio 2 sin descuento</option>
                      <option value="Precio 3 sin descuento">Precio 3 sin descuento</option>
                      <option value="Precio 4 sin descuento">Precio 4 sin descuento</option>
                      <option value="Precio modificable">Precio modificable</option>
                    </Field>  
                    {/* {touched.municipio && errors.municipio && <div style={{marginTop: '0'}} className='generate__error '>{errors.municipio}</div>}    */}
                  </div>

                  <div className='generate__selectValidation'>
                  <Field as="select" name="tipoPedido" className='settings__selectInput'>
                      <option value='Cliente Web'>Cliente Web</option>
                      <option value="Externo">Externo</option>
                      <option value="Interno">Interno</option>
                    </Field>  
                    {touched.tipoPedido && errors.tipoPedido && <div style={{marginTop: '0'}} className='generate__error '>{errors.municipio}</div>}   
                  </div>
              </div>
  
              <hr />
            </div>
  
  
            <div className='generate__form-section'>
              <p className='generate__sectionName'>Datos del Pedido</p>
              <div>
                <label className='generate__label'>
                  Pedido: 
                  <textarea 
                    type="text" 
                    name="pedido" 
                    placeholder='Buen día con gusto surtimos su pedido.
Apóyame enviando una lista detallada con la cantidad, aroma, medida y producto que necesita.
FAVOR DE DAR ENTER POR CADA PRODUCTO DIFERENTE.'
                    className='generate__textbox' 
                    value={values.pedido}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                   {touched.pedido && errors.pedido && <div style={{marginTop: '0'}} className='generate__error '>{errors.pedido}</div>}
                </label>
              </div>
  
              <div>
                <label className='generate__label'>
                  Cargar Archivo: 
                  <input 
                    type="file" 
                    multiple
                    name="imagen-pedido" 
                    className='generate__input-file' 
                    onChange={ onFileInputChange }
                  />
                </label>
              </div>
  
              <div className='generate__pedido-elements'>
                <label className='generate__label'>
                  Fecha de Entrega: 
                  <input 
                    type="date" 
                    name="limite" 
                    className='generate__input-limite'
                    value={values.limite}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                 {touched.limite && errors.limite && <div style={{marginTop: '0'}} className='generate__error'>{errors.limite}</div>}
                </label>
              </div>

              <div style={{marginTop: '20px'}}>
                <label className='generate__label'>
                  Comentarios Adicionales: 
                  <textarea 
                    type="text" 
                    name="comentarios" 
                    placeholder='Agrega observaciones de tu pedido o referencias de tu domicilio aquí'
                    className='generate__textboxComentarios' 
                    value={values.comentarios}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                 </label>
              </div>
  
              <hr />
            </div>
  
  
            <div className='generate__form-section'>
              <p className='generate__sectionName'>Datos del Pago</p>
              <div className='generate__pago-selects'>
  
              <div className='generate__labeledSelect'>
                  <p className='generate__label-selects'>
                    Requiere Factura:
                  </p>
                  <Field as="select" name="factura" className='settings__selectInput'>
                    <option value="No">No</option>
                    <option value="Sí">Sí</option>
                  </Field>  
                </div>
  

                <div className='generate__labeledSelect'>
                  <p className='generate__label-selects'>
                    Método de Pago:
                  </p>
                  <Field as="select" name="metodoPago" className='settings__selectInput'>
                  <option value="Efectivo">Efectivo</option>
                    <option value="Transferencia">Transferencia</option>
                    <option value="Cheque">Cheque</option>
                    <option value="Por Definir">Por Definir</option>
                  </Field>  
                </div>

                <div className='generate__labeledSelect' style={values.factura === "No" ? {display: "none"} : null}>
                  <p className='generate__label-selects'>
                    Forma de Pago:
                  </p>
                  <Field as="select" name="formaPago" className='settings__selectInput'>
                    <option value="Una Exhibición">Una Exhibición</option>
                    <option value="PPD">PPD</option>
                    <option value="Por Definir">Por Definir</option>
                  </Field>  
                </div>
  
  
                <div className='generate__labeledSelect' style={{display: "none"}}>
                    <p className='generate__label-selects'>
                    Costo Extra:
                    </p>
                    <Field as="select" name="costoExtra" className='settings__selectInput'>
                      <option value="No">No</option>
                      <option value="$10">$10</option>
                      <option value="$20">$20</option>
                      <option value="$30">$30</option>
                      <option value="$40">$40</option>
                      <option value="$50">$50</option>
                    </Field>  
                  </div>
  
              </div>  
  
              {(facturaRequerida && !datosFactura) && (
                <div className='generate__factura-inputs'>
    
                <label className='generate__labelFactura'>
                  RFC - Razón Social: 
                  <input 
                      type="text" 
                      placeholder="Ingresa RFC o razón social para facturación" 
                      name="rfc" 
                      className='generate__inputFactura'
                      value={values.rfc}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                    {touched.rfc && errors.rfc && <div className='generate__error '>{errors.rfc}</div>}
                </label>
    
                <label className='generate__labelFactura'>
                  idCFDI: 
                  {/* <small> (La puedes encontrar en la parte superior derecha de tu constancia de situación fiscal)</small>: */}
                  <input 
                    type="text" 
                    placeholder="Ingresa tu idCFDI " 
                    name="idcfdi" 
                    className='generate__inputFactura'
                    value={values.idcfdi}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                  {touched.idcfdi && errors.idcfdi && <div className='generate__error'>{errors.idcfdi}</div>}
                </label>

                <div style={{justifyContent:"left", marginBottom: "30px"}}>
                <label className='generate__label'>
                  Constancia de Situación Fiscal: 
                  <input 
                    type="file" 
                    name="imagen-idcfdi" 
                    className='generate__input-file' 
                    onChange={ onFileInputChangeIdcfdi }
                  />
                </label>
              </div>

                {docID !== "B8ulCbQyT5tUif3WxyAy" && (<div className='generate__error ' style={{color: "blue"}}>Registra tus datos para facturar, la próxima vez que inicies sesión ya no será necesario.</div>)}

                <div style={{flexDirection: "column", justifyContent: "flex-start", display: "none"}} className='generate__labelFactuar generate__noMT'>
                  <Field as="select" name="cfdi" className='settings__selectInput'>
                    <option value=''>Uso de CFDI</option>
                    <option value="Gastos en general">Gastos en general</option>
                    <option value="Adquisión de mercancias">Adquisión de mercancias</option>
                  </Field>  
                  {touched.cfdi && errors.cfdi && <div style={{marginTop: '0'}} className='generate__error'>{errors.cfdi}</div>}

                </div>
    
                </div>
              )}

  
  
            <hr />
            </div>
  
            <div className='generate__form-section'>
              <p className='generate__sectionName'>Datos de contacto</p>



              <div>
                <label className='generate__label'>
                  E-mail de contacto: 
                  <input
                    type="email"
                    placeholder="Email del cliente" 
                    name="email" 
                    className='generate__input'
                    value={values.email}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                   {touched.email && errors.email && <div className='generate__error '>{errors.email}</div>}
                </label>

                <label className='generate__label'>
                  Teléfono de contacto: 
                  <input
                    type="number"
                    placeholder="Teléfono del cliente" 
                    name="telefono" 
                    className='generate__input'
                    value={values.telefono}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                   {touched.telefono && errors.telefono && <div className='generate__error '>{errors.telefono}</div>}
                </label>

              </div>

              <p className='generate__noRegAviso' style={{width: "80%", marginLeft: "10%", marginTop: "20px"}}>Es importante contar con tus datos reales para asegurar la entrega en tiempo y forma. Recuerda que tus datos personales están protegidos.</p>

  
              <div className='generate__pago-selects' style={{display: "none"}}>
                <div className='generate__labeledSelect'>
                    <p className='generate__label-selects'>
                      Asignar Repartidor:
                    </p>
                  <Field as="select" name="repartidor" className='settings__selectInput'>
                    <option value="Libre">Libre</option>
                    <option value="Héctor">Héctor</option>
                    <option value="Martín">Martín</option>
                    <option value="Emergente">Emergente</option>
                    <option value="Cliente">Cliente</option>
                  </Field>  
                  {touched.repartidor && errors.repartidor && <div style={{marginTop: '0'}} className='generate__error'>{errors.repartidor}</div>}
                </div>
  
                <div className='generate__labeledSelect'>
                    <p className='generate__label-selects'>
                      Asignar Sucursal:
                    </p>
                    <Field as="select" name="sucursal" className='settings__selectInput'>
                      <option value="Libre">Libre</option>
                      <option value="Matriz">Matriz</option>
                      <option value="Suc Pablo">Suc Pablo</option>
                      <option value="Suc Villa">Suc Villa</option>
                      <option value="Suc Oriente">Suc Oriente</option>
                      <option value="Bodega">Bodega</option>
                    </Field>  
                  {touched.sucursal && errors.sucursal && <div style={{marginTop: '0'}} className='generate__error'>{errors.sucursal}</div>}
                </div>
              </div>
              <hr />
            </div>
  
  
            <button
              type='submit'
              className='generate__btn generate__btn-primary'
              >
                Generar
            </button>
            </form>
          )}


        </Formik>

      </div>
    </div>
  )
}
